import React from "react";
import "../assests/CSS/FeaturesComponentTwo.css";
import { howItWorksData } from "./data";

const FeaturesComponentTwo = () => {
  return (
    <section className="howitworks-container">
      <h2 className="howitworks-title">{howItWorksData.title}</h2>
      <div className="howitworks-grid">
        {howItWorksData.steps.map((step) => (
          <div key={step.id} className="howitworks-card">
            <span className={`howitworks-card-${step.id}`} >
            <h3 className="howitworks-heading">{step.heading}</h3>
            <p className="howitworks-text">{step.text}</p>
            </span>
            <span className={`howitworks-number howitworks-number-${step.id}`}>
              {step.id}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeaturesComponentTwo;
